import { connect } from 'react-redux';
import { Action } from 'redux';

import { SessionUserSelectors } from '../../app/selectors/SessionInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { homeCloseWelcomeChannelAction } from '../actions/HomeActions';
import { selectShowDefaultWelcomeChannelFromAppState, selectWelcomeChannelFooterFromAppState } from '../selectors/HomeSelectors';
import { HomeUserUtils } from '../utils/HomeUserUtils';
import { WelcomeChannelProps } from '../utils/WelcomeChannelPropsByRole';
import { WelcomeChannel, WelcomeChannelDispatchProps, WelcomeChannelStateProps } from './WelcomeChannel';

export const mapStateToProps: MapStateToProps<WelcomeChannelStateProps> = (state: AppState) => {
  const userRole = HomeUserUtils.getRole(state);
  const webAuthoringEnabled = SessionUserSelectors.canAuthorOnWeb(state);

  const welcomeChannelProps = {
    ...WelcomeChannelProps.getPropsByRole(userRole, webAuthoringEnabled),
    showDefaultWelcomeChannel: selectShowDefaultWelcomeChannelFromAppState(state),
    footer: selectWelcomeChannelFooterFromAppState(state),
  };

  return welcomeChannelProps;
};

export const mapDispatchToProps: MapDispatchToProps<WelcomeChannelDispatchProps> = (dispatch) => ({
  closeWelcomeChannel: () => {
    dispatch(homeCloseWelcomeChannelAction());
  },
  dispatchAction: (action: Action) => dispatch(action)
});

export const ConnectedWelcomeChannel = connect(mapStateToProps, mapDispatchToProps)(WelcomeChannel);
